import { PATH_FIXED_LAYOUT_EDITOR, PATH_FIXED_LAYOUT_EDITOR_DEMO } from 'app/router/routesConfigFixedLayout';
import { USER_ROLES } from 'app/models/user';

const FIXED_LAYOUT_EDITOR_PATHS = new Set([PATH_FIXED_LAYOUT_EDITOR, PATH_FIXED_LAYOUT_EDITOR_DEMO]);

export function fixedLayout(path, user, settings) {
  if (!FIXED_LAYOUT_EDITOR_PATHS.has(path)) return true;

  return !settings?.cms_have_fixed_layout_editor_role || USER_ROLES.adminFixedLayout === user?.role_guid;
}
